import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigationHandlers } from "../utils/hooks/useNavigationHandlers";
import Button from "./Button";

const NextButton = ({
  to,
  onClick,
  disabled,
  disabledReason = "",
  loading = false,
  loadingLabel,
  className = "",
}) => {
  const { t } = useTranslation();
  const { handleNext } = useNavigationHandlers();

  const handleClick = () => {
    if (disabled || loading) return;
    if (onClick) {
      onClick(); // use passed logic
    } else if (to) {
      handleNext(to); // fallback navigation
    }
  };

  return (
    <Button
      className={`w-full ${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      disabled={disabled}
      disabledReason={disabledReason}
      loading={loading}
      loadingLabel={loadingLabel || t("loading")}
      onClick={handleClick}
    >
      {t('next')}
    </Button>
  );
};

export default NextButton;
